<template>
  <v-combobox
    v-model="selected"
    :items="items"
    :search-input.sync="search"
    :label="label"
    :disabled="disabled"
    required="true"
  >
    <template v-slot:no-data>
      <v-list-item v-if="search && search.length > 10">
        <v-list-item-content>
          <v-list-item-title>
            No results matching "<strong>{{ search }}</strong
            >".
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-combobox>
</template>
          
<script>
// import { QUERY_DATASETS_BY_NAME } from "@/queries/datasets";

export default {
  name: "VSearchBox",
  props: {
    value: { type: String, default: "" },
    options: { type: Object, required: true },
    schema: { type: Object, required: true },
    fullSchema: { type: Object, required: true },
    fullKey: { type: String, required: true },
    label: { type: String, default: "" },
    htmlDescription: { type: String, default: "" },
    disabled: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    rules: { type: Array, required: true },
    on: { type: Object, required: true },
  },
  data: () => ({
    selected: "",
    items: [],
    search: null,
  }),
  watch: {
    selected: function (val) {
      this.on.input(val);
    },
    search: async function (val) {
      console.log(val);
      // if (val && val.length > 3) {
      //   const { data } = await this.$apollo.query({
      //     query: QUERY_DATASETS_BY_NAME,
      //     variables: {
      //       name: val,
      //     },
      //   });
      //   this.items = data.authEntry.datasets.map((dataset) => dataset.name);
      // }
    },
  },
  mount: function () {
    this.selected = this.value;
  },
  methods: {},
};
</script>
